/**
 * Stable ids on an API error body. The human sentence stays in `message`.
 * Add a code here in the same change that throws it.
 */
export const API_ERROR_CODES = [
  'ACCOUNT_HAS_NO_STATEMENT_PERIOD',
  'ADD_AT_LEAST_ONE_BORROWER_BEFORE_GENERATING_A_PRE_APPROVAL_LETTER',
  'ADD_BORROWERS_BEFORE_EXTRACTING_A_CREDIT_REPORT',
  'ADD_EMPLOYMENT_BEFORE_EXTRACTING_A_PAYSTUB',
  'ADD_EMPLOYMENT_ON_THE_EMPLOYMENT_TAB_BEFORE_EXTRACTING_A_PAYSTUB',
  'ADD_THE_SUBJECT_PROPERTY_BEFORE_RECORDING_APPRAISALS',
  'ADVERSE_ACTION_NOT_FOUND',
  'ALL_DOCUMENTS_MUST_BELONG_TO_THIS_LOAN_UPLOAD_FILES_FIRST',
  'ALL_OWNER_BORROWERS_MUST_BELONG_TO_THIS_LOAN',
  'ALL_SUBJECT_BORROWERS_MUST_BELONG_TO_THIS_LOAN',
  'ALREADY_A_MEMBER_OF_THIS_COMPANY',
  'AMOUNT_TOO_LARGE',
  'AN_INVITATION_IS_ALREADY_PENDING_FOR_THAT_EMAIL',
  'AN_INVITATION_IS_ALREADY_PENDING_FOR_THIS_APPLICANT',
  'APPRAISAL_NOT_FOUND',
  'ASYNC_EXTRACT_ALWAYS_PERSISTS_OMIT_PERSIST_OR_SET_TRUE',
  'ATTACHMENT_NOT_FOUND',
  'ATTORNEY_EMAIL_BLOCKED',
  'ATTORNEY_IS_ALREADY_LINKED_TO_THIS_COMPANY',
  'ATTORNEY_IS_NOT_LINKED_TO_THIS_COMPANY',
  'ATTORNEY_NOT_FOUND',
  'AT_LEAST_ONE_OWNER_BORROWER_IS_REQUIRED',
  'AT_LEAST_ONE_PLATFORM_ADMIN_MUST_REMAIN',
  'A_CLOSING_DISCLOSURE_CAN_BE_CREATED_AFTER_THIS_LOAN_IS_PRE_APPROVED',
  'A_LOAN_ESTIMATE_DRAFT_IS_CREATED_WHEN_THIS_LOAN_IS_MARKED_PRE_APPROVED',
  'A_LOAN_MAY_HAVE_AT_MOST_BORROWERS',
  'A_POLICY_CANNOT_REPLACE_ITSELF',
  'A_RULE_INSTANCE_MAY_BE_GLOBAL_OR_LINKED_TO_AT_MOST_ONE_PROGRAM',
  'A_TAX_RETURN_FOR_ALREADY_EXISTS',
  'A_USER_WITH_THAT_EMAIL_ALREADY_EXISTS',
  'BANK_ACCOUNT_NOT_FOUND',
  'BANK_STATEMENT_EXTRACT_FAILED',
  'BANK_STATEMENT_EXTRACT_REQUIRES_A_PDF',
  'BANK_STATEMENT_EXTRACT_VIA_TRIGGER_FAILED_AUTH_SET_TRIGGER_SECRET_KEY_FROM_THE_TRIGGER_DEV_DASHB',
  'BANK_STATEMENT_NOT_FOUND',
  'BANK_STATEMENT_NO_TEXT',
  'BANK_STATEMENT_PDF_PARSE_IS_UNAVAILABLE',
  'BANK_TRANSACTION_NOT_FOUND',
  'BORROWERID_IS_REQUIRED_FOR_BORROWER_INVITATIONS',
  'BORROWERS_CANNOT_ACCESS_UNDERWRITING_DOCUMENTS_ON_THIS_LOAN',
  'BORROWER_NOT_FOUND',
  'BORROWER_POSITION_TAKEN',
  'CALCULATED_FEES_CANNOT_BE_EDITED_THEY_UPDATE_FROM_LE_TERMS_AND_DATES',
  'CALCULATED_FEES_CANNOT_BE_REMOVED_THEY_ARE_MAINTAINED_BY_THE_SYSTEM',
  'CANNOT_IMPORT_NO_BORROWERS_ON_LOAN',
  'CANNOT_INVITE_A_LENDER_USER_TO_A_NON_LENDER_COMPANY',
  'CANNOT_INVITE_ORIGINATOR_ROLES_TO_A_NON_ORIGINATOR_COMPANY',
  'CANNOT_OVERRIDE_LOAN_HAS_NO_LENDER',
  'CANNOT_UNSET_PRIMARY_WITHOUT_DESIGNATING_ANOTHER_PRIMARY_BORROWER',
  'CHANGED_CIRCUMSTANCE_DETAILS_REQUIRED',
  'CHOOSE_A_LENDER_OR_TABLE_FUNDING_LENDER_BEFORE_A_LOAN_PROGRAM',
  'CLOSING_DISCLOSURE_FEE_NOT_FOUND',
  'CLOSING_DISCLOSURE_NOT_FOUND',
  'COMPANYID_AND_COMPANYROLE_ARE_REQUIRED',
  'COMPANY_DEFAULT_FEE_NOT_FOUND',
  'COMPANY_HAS_NO_LOGO',
  'COMPANY_MUST_BE_A_LENDER_AN_ORIGINATOR_OR_BOTH',
  'COMPANY_NOT_FOUND',
  'COMPLETE_THE_LOAN_BEFORE_THIS_STATUS',
  'CONDITION_NOT_FOUND',
  'CONTRACT_NOT_FOUND_ON_THIS_LOAN',
  'COULD_NOT_GENERATE_A_FREE_LOAN_REFERENCE_TRY_AGAIN',
  'COULD_NOT_MATCH_PAYSTUB_EMPLOYER_TO_A_BORROWER_EMPLOYMENT_PASS_EMPLOYMENTID_OR_UPDATE_EMPLOYMENT',
  'COULD_NOT_READ_EMPLOYER_NAME_FROM_PAYSTUB_AND_BORROWER_HAS_MULTIPLE_EMPLOYMENTS_PASS_EMPLOYMENTI',
  'COUNTY_ALREADY_EXISTS_IN',
  'COUNTY_IS_IN_NOT',
  'COUNTY_NAME_ALREADY_EXISTS_IN_THAT_STATE',
  'COUNTY_NOT_FOUND',
  'COUNTY_NOT_FOUND_IN_THE_PLATFORM_CATALOG',
  'CREDIT_REPORT_EXTRACT_FAILED',
  'CREDIT_REPORT_EXTRACT_REQUIRES_A_PDF_XML_ATTACH_REMAINS_ON_THE_MANUAL_FORM',
  'CREDIT_REPORT_EXTRACT_VIA_TRIGGER_FAILED_AUTH',
  'CREDIT_REPORT_NOT_FOUND',
  'CREDIT_REPORT_PDF_PARSE_IS_UNAVAILABLE',
  'CREDIT_REPORT_SUBJECT_NOT_FOUND',
  'DEFAULT_FEE_NOT_FOUND',
  'DOCUMENTID_MUST_BE_A_PDF',
  'DOCUMENTID_MUST_BE_A_PDF_OR_IMAGE_PAYSTUB',
  'DOCUMENTID_MUST_REFERENCE_A_DOCUMENT_ON_THIS_LOAN',
  'DOCUMENTID_NOT_FOUND_ON_THIS_LOAN',
  'DOCUMENT_ALREADY_ATTACHED_TO_THIS_REPORT',
  'DOCUMENT_NOT_FOUND',
  'EACH_EMPLOYMENT_ID_CAN_ONLY_BE_SENT_ONCE',
  'EMAIL_NOT_FOUND',
  'EMPLOYER_MATCHES_MULTIPLE_EMPLOYMENTS_PASS_EMPLOYMENTID_TO_DISAMBIGUATE',
  'EMPLOYMENTID_IS_NOT_AN_EMPLOYMENT_ON_THIS_BORROWER',
  'EMPLOYMENT_ALREADY_LISTED',
  'EMPLOYMENT_NOT_FOUND',
  'EMPLOYMENT_NOT_FOUND_ON_THIS_BORROWER',
  'ENTER_THE_CHANGED_CIRCUMSTANCE_THAT_REQUIRES_THIS_REVISED_LOAN_ESTIMATE',
  'ERROR_INSTANCEOF_ERROR_ERROR_MESSAGE_UNKNOWN_PIXELSIGN_ENVELOPE_STATUS',
  'ERROR_INSTANCEOF_ERROR_ERROR_MESSAGE_UNKNOWN_PIXELSIGN_SIGNER_FIELD',
  'ESCROW_POLICY_CONFLICT',
  'ESCROW_POLICY_NOT_FOUND',
  'EXTRACTED_PERIODEND_IS_BEFORE_PERIODSTART',
  'EXTRACT_JOB_MISSING_DOCUMENTID',
  'EXTRACT_MISSING_VALID',
  'EXTRACT_MISSING_VALID_YYYY_MM_DD',
  'EXTRACT_PRODUCED_NO_ACCOUNTS',
  'EXTRACT_VALIDATION_FAILED',
  'FILE_EXCEEDS_15_MB_LIMIT',
  'FILE_EXCEEDS_25_MB_LIMIT',
  'FILE_IS_REQUIRED',
  'FILE_IS_REQUIRED_MULTIPART_FIELD_FILE',
  'FILE_MUST_BE_A_FORM_1003_PDF_PDF',
  'FILE_MUST_BE_A_MISMO_XML_DOCUMENT_XML',
  'FILL_IN_BEFORE_GENERATING_LEGAL_DOCUMENTS',
  'FLOOD_ZONE_CATEGORY_MUST_BE_EMPTY_WHEN_THE_PROPERTY_IS_NOT_IN_A_FLOOD_ZONE',
  'FORM_1099_NOT_FOUND',
  'HOA_NOT_FOUND_ON_THIS_LOAN',
  'IMPORT_REQUIRES_AT_LEAST_ONE_BORROWER',
  'INCOME_METHOD_NOT_AVAILABLE',
  'INSURANCE_DOCUMENT_MUST_BE_A_PDF',
  'INSURANCE_NOT_FOUND',
  'INTENT_TO_PROCEED_BEFORE_APPLICATION',
  'INVALID_DOCUMENT_KIND',
  'INVALID_EMAIL_OR_PASSWORD',
  'INVALID_EXTRACT_OPTIONS',
  'INVALID_FEE_AMOUNT',
  'INVALID_LENDER_COMPANY',
  'INVALID_ORIGINATOR_COMPANY',
  'INVALID_TABLE_FUNDING_LENDER_COMPANY',
  'INVALID_XML',
  'INVITATION_HAS_EXPIRED',
  'INVITATION_IS_MISSING_COMPANY_DETAILS',
  'INVITATION_IS_MISSING_LOAN_DETAILS',
  'INVITATION_NOT_FOUND',
  'INVITATION_NOT_FOUND_OR_ALREADY_ACCEPTED',
  'ISSUE_A_CLOSING_DISCLOSURE_FIRST',
  'IS_NOT_CONFIGURED_ON_THE_API',
  'KEYWORD_NOT_FOUND',
  'LENDERCOMPANYID_MUST_REFERENCE_A_LENDER_COMPANY',
  'LENDER_COMPANY_NOT_FOUND',
  'LINKEDLIABILITYID_MUST_REFERENCE_A_LIABILITY_ON_THIS_LOAN',
  'LINKEDREALESTATEID_MUST_REFERENCE_REAL_ESTATE_ON_THIS_LOAN',
  'LOANID_IS_REQUIRED_FOR_BORROWER_INVITATIONS',
  'LOANPROGRAMID_MUST_BELONG_TO_THE_TABLE_FUNDING_LENDER_WHEN_SET_OTHERWISE_THE_LENDER',
  'LOANPROGRAMID_REQUIRES_A_TABLE_FUNDING_LENDER_OR_LENDER_COMPANY',
  'LOAN_ESTIMATE_CANNOT_BE_REVISED_AFTER_THE_CLOSING_DISCLOSURE',
  'LOAN_ESTIMATE_FEE_NOT_FOUND',
  'LOAN_ESTIMATE_MISSING_PROPERTY_COSTS',
  'LOAN_ESTIMATE_NOT_FOUND',
  'LOAN_ISSUE_BLOCKED',
  'LOAN_IS_NOT_EMPTY_IMPORT_REQUIRES_NO_BORROWERS_ASSETS_GIFTS_LIABILITIES_OR_REO',
  'LOAN_NOT_FOUND',
  'LOAN_NOT_READY',
  'LOAN_PROGRAM_MUST_BELONG_TO_THE_TABLE_FUNDING_LENDER_WHEN_SET_OTHERWISE_THE_LENDER',
  'LOAN_PROGRAM_NOT_FOUND',
  'LOAN_REFERENCE_IS_ALREADY_USED_BY_ANOTHER_LOAN',
  'LOAN_STATUS_BLOCKED_BY_TRID',
  'LOAN_STATUS_CHANGED_WHILE_THIS_UPDATE_WAS_IN_PROGRESS_RELOAD_THE_LOAN_AND_TRY_AGAIN',
  'LOAN_STATUS_REJECTED',
  'LOGO_FILE_IS_EMPTY',
  'LOGO_MUST_BE_2_MB_OR_SMALLER',
  'LOGO_MUST_BE_PNG_JPEG_WEBP_GIF_OR_SVG',
  'MISMO_IMPORT_OPTIONS_INVALID',
  'MISMO_VALIDATION_FAILED',
  'MISMO_XML_MUST_CONTAIN_A_DEAL_DEAL_SETS_DEAL_SET_DEALS_DEAL',
  'MISSING_PERMISSION',
  'MISSING_PERMISSION_INVITATION_CREATE',
  'MISSING_PERMISSION_INVITATION_READ',
  'MISSING_PERMISSION_LOAN_CREATE',
  'MISSING_PERMISSION_LOAN_DOCUMENT_READ',
  'MISSING_PERMISSION_LOAN_DOCUMENT_UPLOAD',
  'MISSING_PERMISSION_LOAN_UPDATE',
  'MISSING_PERMISSION_LOAN_UPDATE_REQUIRED_TO_IMPORT_BORROWERS',
  'MISSING_PERMISSION_TO_CHANGE_LOAN_STATUS_ON_THE_LENDER_COMPANY',
  'NOTICE_DATE_BEFORE_DECISION',
  'NOT_A_MEMBER_OF_THIS_COMPANY',
  'NOT_FOUND',
  'NO_BORROWER_PARTIES_FOUND_IN_MISMO_DEAL',
  'NO_PDF_ON_THIS_TITLE_COMMITMENT',
  'NO_SIGNATURE_ENVELOPE_FOR_THIS_LOAN_ESTIMATE',
  'NO_VESTING_DEED_ON_THIS_TITLE_FILE',
  'ONE_OR_MORE_ARE_NOT_ON_THIS_LENDER_COMPANY',
  'ONLY_AN_IN_PROGRESS_SIGNATURE_CAN_BE_VOIDED',
  'ONLY_A_DRAFT_CLOSING_DISCLOSURE_CAN_BE_CHANGED',
  'ONLY_A_DRAFT_LOAN_ESTIMATE_CAN_BE_EDITED_PUBLISHED_OR_DELETED',
  'ONLY_LENDER_COMPANIES_CAN_MANAGE_LINKED_ATTORNEYS',
  'ONLY_LENDER_COMPANIES_CAN_SET_A_PREFERRED_SERVICER',
  'ONLY_LENDER_STAFF_CAN_MAKE_THIS_DECISION',
  'ONLY_LENDER_STAFF_CAN_OVERRIDE_THIS_BLOCK',
  'ONLY_LENDER_USERS_OF_THE_LENDER_OR_TABLE_FUNDING_LENDER_OR_PLATFORM_ADMINS_CAN_OVERRIDE_GUIDELIN',
  'ONLY_MORTGAGE_TRADELINES_CAN_BE_LINKED_TO_REAL_ESTATE',
  'ONLY_PLATFORM_ADMINS_CAN_CREATE_COMPANIES',
  'ONLY_PLATFORM_ADMINS_CAN_DO_THIS',
  'ONLY_PLATFORM_ADMINS_CAN_INVITE_USERS',
  'ONLY_PLATFORM_ADMINS_CAN_LIST_USER_INVITATIONS',
  'ONLY_PLATFORM_ADMINS_CAN_MANAGE_COUNTIES',
  'ONLY_PLATFORM_ADMINS_CAN_MANAGE_PLATFORM_SETTINGS',
  'ONLY_PLATFORM_ADMINS_CAN_MANAGE_SERVICERS',
  'ONLY_PLATFORM_ADMINS_CAN_MANAGE_TITLE_COMPANIES',
  'ONLY_PLATFORM_ADMINS_CAN_MANAGE_USERS',
  'ONLY_PLATFORM_ADMINS_CAN_RESEND_USER_INVITATIONS',
  'ONLY_PLATFORM_ADMINS_CAN_UPDATE_COMPANIES',
  'ONLY_PLATFORM_ADMINS_MAY_UPDATE',
  'ONLY_STAFF_ON_THIS_LOAN_CAN_SEE_THIS',
  'ORIGINATORCOMPANYID_MUST_REFERENCE_AN_ORIGINATOR_COMPANY',
  'ORIGINATORCOMPANYID_OR_LENDERCOMPANYID_IS_REQUIRED_WHEN_CREATING_A_LOAN_FROM_MISMO',
  'ORIGINATOR_COMPANIES_REQUIRE_A_COMPANY_NMLS_NUMBER',
  'ORIGINATOR_COMPANY_NOT_FOUND',
  'ORIGINATOR_SIGNER_IS_REQUIRED',
  'PAYSTUB_EXTRACT_FAILED',
  'PAYSTUB_EXTRACT_REQUIRES_A_PDF_OR_IMAGE_JPG_PNG_WEBP_GIF_HEIC',
  'PAYSTUB_EXTRACT_VIA_TRIGGER_FAILED_AUTH_SET_TRIGGER_SECRET_KEY_FROM_THE_TRIGGER_DEV_DASHBOARD',
  'PAYSTUB_NOT_FOUND',
  'PAYSTUB_PDF_PARSE_IS_UNAVAILABLE',
  'PDF_1003_IMPORT_NEEDS_ON_THE_API',
  'PDF_EXTRACT_FAILED',
  'PDF_GENERATION_FAILED',
  'PDF_PARSE_FAILED',
  'PDF_SERVICE_IS_NOT_CONFIGURED_SET_PDF_SERVICE_URL',
  'PDF_SERVICE_REDIRECTED_CHECK_PDF_SERVICE_URL_SCHEME_HOST',
  'PDF_SERVICE_UNREACHABLE',
  'PERIODEND_MUST_BE_ON_OR_AFTER_PERIODSTART',
  'PERSONAL_NMLS_NUMBER_IS_REQUIRED_FOR_RMLO_USERS',
  'PIXELSIGN_IS_UNREACHABLE',
  'PIXELSIGN_RETURNED_AN_UNEXPECTED_ENVELOPE_SHAPE',
  'PIXELSIGN_WEBHOOKS_ARE_NOT_CONFIGURED_SET_PIXELSIGN_WEBHOOK_SECRET',
  'PIXELSIGN_WEBHOOK_PAYLOAD_IS_INVALID',
  'PIXELSIGN_WEBHOOK_REJECTED',
  'PLATFORM_ADMIN_ONLY',
  'PLATFORM_ADMIN_REQUIRED',
  'PRE_APPROVAL_LETTER_IS_ONLY_AVAILABLE_WHEN_THE_LOAN_IS_PRE_APPROVED_OR_FURTHER_ALONG',
  'PRE_APPROVAL_LETTER_REQUIRES_PROGRAM_PURCHASE_PRICE_MAX_CLTV_AND_RATE',
  'PRE_APPROVAL_NOT_FOUND',
  'PRE_APPROVAL_NOT_FOUND_ON_THIS_LOAN',
  'PRIORINSURANCEID_MUST_BE_A_POLICY_ON_THIS_LOAN',
  'PROGRAM_FEE_NOT_FOUND',
  'PROGRAM_TERMS_INVALID',
  'PROVIDE_A_FILE_OR_DOCUMENTID',
  'PROVIDE_MULTIPART_FIELD_FILE_PDF_OR_BODY_DOCUMENTID',
  'PROVIDE_MULTIPART_FIELD_FILE_PDF_OR_IMAGE_OR_BODY_DOCUMENTID',
  'PUBLISH_THE_LOAN_ESTIMATE_BEFORE_SENDING_IT_FOR_SIGNATURE',
  'RECEIPT_DATE_BEFORE_ISSUE_DATE',
  'RECEIPT_ONLY_ON_ISSUED_DISCLOSURE',
  'REMINDERS_CAN_ONLY_BE_SENT_WHILE_THE_ENVELOPE_IS_AWAITING_SIGNATURES',
  'REPORTDATE_IS_REQUIRED',
  'RESOURCE_NOT_FOUND',
  'SELECTED_LOAN_PROGRAM_IS_INACTIVE',
  'SERVICER_NOT_FOUND',
  'SETTLEMENT_AGENT_MUST_BELONG_TO_THE_SELECTED_TITLE_COMPANY',
  'SIGNATURE_PARTY_INVALID',
  'SIGNED_DOCUMENT_IS_MISSING',
  'SIGNED_LOAN_ESTIMATE_IS_NOT_AVAILABLE_YET',
  'SPOUSE_CANNOT_BE_THE_SAME_BORROWER',
  'SPOUSE_COBORROWER_IS_NOT_ON_THIS_LOAN',
  'STAFF_MAY_NOT_UPDATE_FIELD',
  'SUBJECT_PROPERTY_NOT_FOUND_ON_THIS_LOAN',
  'SURVEY_MUST_BE_A_PDF',
  'SWITCH_TO_THIS_COMPANY_BEFORE_INVITING_MEMBERS',
  'TABLEFUNDINGLENDERCOMPANYID_MUST_REFERENCE_A_LENDER_COMPANY',
  'TABLE_FUNDING_LENDER_COMPANY_NOT_FOUND',
  'TAX_RETURN_NOT_FOUND',
  'THAT_BORROWER_IS_ALREADY_LINKED_TO_ANOTHER_SUBJECT_ON_THIS_REPORT',
  'THE_HTML_EXCEEDS_PIXELSIGN_S_SIZE_LIMIT',
  'THE_HTML_IS_MISSING_SIGNATURE_FIELD_MARKERS',
  'THE_ISSUE_DATE_CAN_T_BE_IN_THE_FUTURE',
  'THE_LOAN_STATUS_CHANGED_RELOAD_AND_TRY_AGAIN',
  'THE_SIGNED_LOAN_ESTIMATE_IS_AVAILABLE_AFTER_EVERY_SIGNER_COMPLETES',
  'THIS_APPLICANT_ALREADY_HAS_PORTAL_ACCESS',
  'THIS_CLOSING_DISCLOSURE_IS_NO_LONGER_A_DRAFT_RELOAD_IT_TO_SEE_THE_LATEST_VERSION',
  'THIS_CONFIG_ERROR_PIXELSIGN_IS_NOT_CONFIGURED_PIXELSIGN_IS_NOT_CONFIGURED_SET_PIXELSIGN_API_KEY',
  'THIS_LOAN_ALREADY_HAS_A_DRAFT_CLOSING_DISCLOSURE',
  'THIS_LOAN_ALREADY_HAS_A_DRAFT_LOAN_ESTIMATE',
  'THIS_LOAN_DOES_NOT_INCLUDE_THAT_LEGAL_INSTRUMENT',
  'THIS_LOAN_ESTIMATE_ALREADY_HAS_A_SIGNATURE_IN_PROGRESS_VOID_IT_TO_SEND_AGAIN',
  'THIS_LOAN_ESTIMATE_IS_NO_LONGER_A_DRAFT_RELOAD_IT_TO_SEE_THE_LATEST_VERSION',
  'THIS_LOAN_ESTIMATE_VERSION_IS_ALREADY_SIGNED',
  'THIS_LOAN_IS_CLOSED_AND_CAN_NO_LONGER_BE_CHANGED',
  'THIS_RESOURCE_CAN_ONLY_BE_MANAGED_FOR_LENDER_COMPANIES',
  'TITLE_COMMITMENT_MUST_BE_A_PDF',
  'TITLE_COMMITMENT_NOT_FOUND',
  'TITLE_COMPANY_NOT_FOUND',
  'TITLE_FILE_NOT_FOUND_ON_THIS_LOAN',
  'TITLE_REQUEST_BLOCKED',
  'TOKEN_IS_REQUIRED',
  'TRADELINE_NOT_FOUND',
  'TRIGGER_DEV_UNREACHABLE_RUN_NPM_RUN_TRIGGER_DEV_IN_API',
  'TRIGGER_DEV_UNREACHABLE_RUN_NPM_RUN_TRIGGER_DEV_IN_API_FOR_LOCAL_WORKERS',
  'TRUSTEEID_MUST_BELONG_TO_THE_TABLE_FUNDING_LENDER_WHEN_SET_OTHERWISE_THE_LENDER',
  'TRUSTEEID_REQUIRES_A_TABLE_FUNDING_LENDER_OR_LENDER_COMPANY',
  'TRUSTEE_NOT_FOUND',
  'UNAUTHORIZED',
  'UNDERWRITING_BLOCKED',
  'UNDERWRITING_GUIDELINE_NOT_FOUND',
  'UNDERWRITING_RULE_INVALID',
  'UNDERWRITING_RULE_NOT_FOUND',
  'UNKNOWN_CURRENT_LOAN_STATUS',
  'UNKNOWN_LEGAL_INSTRUMENT',
  'UNKNOWN_RULE_CODE_ON_EXISTING_ROW',
  'UNKNOWN_TARGET_STATUS',
  'UNSUPPORTED_FILE_TYPE',
  'UNSUPPORTED_INVITATION_KIND',
  'UPLOADED_FILE_IS_EMPTY',
  'UPLOAD_A_TITLE_COMMITMENT_PDF',
  'URLA_EXTRACT_FAILED',
  'URLA_PARSE_FAILED',
  'USER_IS_ALREADY_A_MEMBER_OF_THIS_COMPANY',
  'USER_NOT_FOUND',
  'VERIFIEDBALANCEDOCUMENTID_MUST_BE_A_DOCUMENT_ON_THIS_LOAN',
  'VESTING_DEED_MUST_BE_A_PDF',
  'W_2_NOT_FOUND',
  'YOU_ARE_NOT_A_MEMBER_OF_THAT_COMPANY',
  'YOU_CANNOT_REMOVE_YOUR_OWN_ADMIN_ACCESS',
  'YOU_CAN_ONLY_ATTACH_COMPANIES_YOU_BELONG_TO',
  'YOU_DO_NOT_HAVE_ACCESS_TO_THIS_LOAN',
  'YOU_DO_NOT_HAVE_ACCESS_TO_UPDATE_THIS_LOAN',
] as const

export const API_ERROR_CODE = {
  ACCOUNT_HAS_NO_STATEMENT_PERIOD: 'ACCOUNT_HAS_NO_STATEMENT_PERIOD',
  ADD_AT_LEAST_ONE_BORROWER_BEFORE_GENERATING_A_PRE_APPROVAL_LETTER: 'ADD_AT_LEAST_ONE_BORROWER_BEFORE_GENERATING_A_PRE_APPROVAL_LETTER',
  ADD_BORROWERS_BEFORE_EXTRACTING_A_CREDIT_REPORT: 'ADD_BORROWERS_BEFORE_EXTRACTING_A_CREDIT_REPORT',
  ADD_EMPLOYMENT_BEFORE_EXTRACTING_A_PAYSTUB: 'ADD_EMPLOYMENT_BEFORE_EXTRACTING_A_PAYSTUB',
  ADD_EMPLOYMENT_ON_THE_EMPLOYMENT_TAB_BEFORE_EXTRACTING_A_PAYSTUB: 'ADD_EMPLOYMENT_ON_THE_EMPLOYMENT_TAB_BEFORE_EXTRACTING_A_PAYSTUB',
  ADD_THE_SUBJECT_PROPERTY_BEFORE_RECORDING_APPRAISALS: 'ADD_THE_SUBJECT_PROPERTY_BEFORE_RECORDING_APPRAISALS',
  ADVERSE_ACTION_NOT_FOUND: 'ADVERSE_ACTION_NOT_FOUND',
  ALL_DOCUMENTS_MUST_BELONG_TO_THIS_LOAN_UPLOAD_FILES_FIRST: 'ALL_DOCUMENTS_MUST_BELONG_TO_THIS_LOAN_UPLOAD_FILES_FIRST',
  ALL_OWNER_BORROWERS_MUST_BELONG_TO_THIS_LOAN: 'ALL_OWNER_BORROWERS_MUST_BELONG_TO_THIS_LOAN',
  ALL_SUBJECT_BORROWERS_MUST_BELONG_TO_THIS_LOAN: 'ALL_SUBJECT_BORROWERS_MUST_BELONG_TO_THIS_LOAN',
  ALREADY_A_MEMBER_OF_THIS_COMPANY: 'ALREADY_A_MEMBER_OF_THIS_COMPANY',
  AMOUNT_TOO_LARGE: 'AMOUNT_TOO_LARGE',
  AN_INVITATION_IS_ALREADY_PENDING_FOR_THAT_EMAIL: 'AN_INVITATION_IS_ALREADY_PENDING_FOR_THAT_EMAIL',
  AN_INVITATION_IS_ALREADY_PENDING_FOR_THIS_APPLICANT: 'AN_INVITATION_IS_ALREADY_PENDING_FOR_THIS_APPLICANT',
  APPRAISAL_NOT_FOUND: 'APPRAISAL_NOT_FOUND',
  ASYNC_EXTRACT_ALWAYS_PERSISTS_OMIT_PERSIST_OR_SET_TRUE: 'ASYNC_EXTRACT_ALWAYS_PERSISTS_OMIT_PERSIST_OR_SET_TRUE',
  ATTACHMENT_NOT_FOUND: 'ATTACHMENT_NOT_FOUND',
  ATTORNEY_EMAIL_BLOCKED: 'ATTORNEY_EMAIL_BLOCKED',
  ATTORNEY_IS_ALREADY_LINKED_TO_THIS_COMPANY: 'ATTORNEY_IS_ALREADY_LINKED_TO_THIS_COMPANY',
  ATTORNEY_IS_NOT_LINKED_TO_THIS_COMPANY: 'ATTORNEY_IS_NOT_LINKED_TO_THIS_COMPANY',
  ATTORNEY_NOT_FOUND: 'ATTORNEY_NOT_FOUND',
  AT_LEAST_ONE_OWNER_BORROWER_IS_REQUIRED: 'AT_LEAST_ONE_OWNER_BORROWER_IS_REQUIRED',
  AT_LEAST_ONE_PLATFORM_ADMIN_MUST_REMAIN: 'AT_LEAST_ONE_PLATFORM_ADMIN_MUST_REMAIN',
  A_CLOSING_DISCLOSURE_CAN_BE_CREATED_AFTER_THIS_LOAN_IS_PRE_APPROVED: 'A_CLOSING_DISCLOSURE_CAN_BE_CREATED_AFTER_THIS_LOAN_IS_PRE_APPROVED',
  A_LOAN_ESTIMATE_DRAFT_IS_CREATED_WHEN_THIS_LOAN_IS_MARKED_PRE_APPROVED: 'A_LOAN_ESTIMATE_DRAFT_IS_CREATED_WHEN_THIS_LOAN_IS_MARKED_PRE_APPROVED',
  A_LOAN_MAY_HAVE_AT_MOST_BORROWERS: 'A_LOAN_MAY_HAVE_AT_MOST_BORROWERS',
  A_POLICY_CANNOT_REPLACE_ITSELF: 'A_POLICY_CANNOT_REPLACE_ITSELF',
  A_RULE_INSTANCE_MAY_BE_GLOBAL_OR_LINKED_TO_AT_MOST_ONE_PROGRAM: 'A_RULE_INSTANCE_MAY_BE_GLOBAL_OR_LINKED_TO_AT_MOST_ONE_PROGRAM',
  A_TAX_RETURN_FOR_ALREADY_EXISTS: 'A_TAX_RETURN_FOR_ALREADY_EXISTS',
  A_USER_WITH_THAT_EMAIL_ALREADY_EXISTS: 'A_USER_WITH_THAT_EMAIL_ALREADY_EXISTS',
  BANK_ACCOUNT_NOT_FOUND: 'BANK_ACCOUNT_NOT_FOUND',
  BANK_STATEMENT_EXTRACT_FAILED: 'BANK_STATEMENT_EXTRACT_FAILED',
  BANK_STATEMENT_EXTRACT_REQUIRES_A_PDF: 'BANK_STATEMENT_EXTRACT_REQUIRES_A_PDF',
  BANK_STATEMENT_EXTRACT_VIA_TRIGGER_FAILED_AUTH_SET_TRIGGER_SECRET_KEY_FROM_THE_TRIGGER_DEV_DASHB: 'BANK_STATEMENT_EXTRACT_VIA_TRIGGER_FAILED_AUTH_SET_TRIGGER_SECRET_KEY_FROM_THE_TRIGGER_DEV_DASHB',
  BANK_STATEMENT_NOT_FOUND: 'BANK_STATEMENT_NOT_FOUND',
  BANK_STATEMENT_NO_TEXT: 'BANK_STATEMENT_NO_TEXT',
  BANK_STATEMENT_PDF_PARSE_IS_UNAVAILABLE: 'BANK_STATEMENT_PDF_PARSE_IS_UNAVAILABLE',
  BANK_TRANSACTION_NOT_FOUND: 'BANK_TRANSACTION_NOT_FOUND',
  BORROWERID_IS_REQUIRED_FOR_BORROWER_INVITATIONS: 'BORROWERID_IS_REQUIRED_FOR_BORROWER_INVITATIONS',
  BORROWERS_CANNOT_ACCESS_UNDERWRITING_DOCUMENTS_ON_THIS_LOAN: 'BORROWERS_CANNOT_ACCESS_UNDERWRITING_DOCUMENTS_ON_THIS_LOAN',
  BORROWER_NOT_FOUND: 'BORROWER_NOT_FOUND',
  BORROWER_POSITION_TAKEN: 'BORROWER_POSITION_TAKEN',
  CALCULATED_FEES_CANNOT_BE_EDITED_THEY_UPDATE_FROM_LE_TERMS_AND_DATES: 'CALCULATED_FEES_CANNOT_BE_EDITED_THEY_UPDATE_FROM_LE_TERMS_AND_DATES',
  CALCULATED_FEES_CANNOT_BE_REMOVED_THEY_ARE_MAINTAINED_BY_THE_SYSTEM: 'CALCULATED_FEES_CANNOT_BE_REMOVED_THEY_ARE_MAINTAINED_BY_THE_SYSTEM',
  CANNOT_IMPORT_NO_BORROWERS_ON_LOAN: 'CANNOT_IMPORT_NO_BORROWERS_ON_LOAN',
  CANNOT_INVITE_A_LENDER_USER_TO_A_NON_LENDER_COMPANY: 'CANNOT_INVITE_A_LENDER_USER_TO_A_NON_LENDER_COMPANY',
  CANNOT_INVITE_ORIGINATOR_ROLES_TO_A_NON_ORIGINATOR_COMPANY: 'CANNOT_INVITE_ORIGINATOR_ROLES_TO_A_NON_ORIGINATOR_COMPANY',
  CANNOT_OVERRIDE_LOAN_HAS_NO_LENDER: 'CANNOT_OVERRIDE_LOAN_HAS_NO_LENDER',
  CANNOT_UNSET_PRIMARY_WITHOUT_DESIGNATING_ANOTHER_PRIMARY_BORROWER: 'CANNOT_UNSET_PRIMARY_WITHOUT_DESIGNATING_ANOTHER_PRIMARY_BORROWER',
  CHANGED_CIRCUMSTANCE_DETAILS_REQUIRED: 'CHANGED_CIRCUMSTANCE_DETAILS_REQUIRED',
  CHOOSE_A_LENDER_OR_TABLE_FUNDING_LENDER_BEFORE_A_LOAN_PROGRAM: 'CHOOSE_A_LENDER_OR_TABLE_FUNDING_LENDER_BEFORE_A_LOAN_PROGRAM',
  CLOSING_DISCLOSURE_FEE_NOT_FOUND: 'CLOSING_DISCLOSURE_FEE_NOT_FOUND',
  CLOSING_DISCLOSURE_NOT_FOUND: 'CLOSING_DISCLOSURE_NOT_FOUND',
  COMPANYID_AND_COMPANYROLE_ARE_REQUIRED: 'COMPANYID_AND_COMPANYROLE_ARE_REQUIRED',
  COMPANY_DEFAULT_FEE_NOT_FOUND: 'COMPANY_DEFAULT_FEE_NOT_FOUND',
  COMPANY_HAS_NO_LOGO: 'COMPANY_HAS_NO_LOGO',
  COMPANY_MUST_BE_A_LENDER_AN_ORIGINATOR_OR_BOTH: 'COMPANY_MUST_BE_A_LENDER_AN_ORIGINATOR_OR_BOTH',
  COMPANY_NOT_FOUND: 'COMPANY_NOT_FOUND',
  COMPLETE_THE_LOAN_BEFORE_THIS_STATUS: 'COMPLETE_THE_LOAN_BEFORE_THIS_STATUS',
  CONDITION_NOT_FOUND: 'CONDITION_NOT_FOUND',
  CONTRACT_NOT_FOUND_ON_THIS_LOAN: 'CONTRACT_NOT_FOUND_ON_THIS_LOAN',
  COULD_NOT_GENERATE_A_FREE_LOAN_REFERENCE_TRY_AGAIN: 'COULD_NOT_GENERATE_A_FREE_LOAN_REFERENCE_TRY_AGAIN',
  COULD_NOT_MATCH_PAYSTUB_EMPLOYER_TO_A_BORROWER_EMPLOYMENT_PASS_EMPLOYMENTID_OR_UPDATE_EMPLOYMENT: 'COULD_NOT_MATCH_PAYSTUB_EMPLOYER_TO_A_BORROWER_EMPLOYMENT_PASS_EMPLOYMENTID_OR_UPDATE_EMPLOYMENT',
  COULD_NOT_READ_EMPLOYER_NAME_FROM_PAYSTUB_AND_BORROWER_HAS_MULTIPLE_EMPLOYMENTS_PASS_EMPLOYMENTI: 'COULD_NOT_READ_EMPLOYER_NAME_FROM_PAYSTUB_AND_BORROWER_HAS_MULTIPLE_EMPLOYMENTS_PASS_EMPLOYMENTI',
  COUNTY_ALREADY_EXISTS_IN: 'COUNTY_ALREADY_EXISTS_IN',
  COUNTY_IS_IN_NOT: 'COUNTY_IS_IN_NOT',
  COUNTY_NAME_ALREADY_EXISTS_IN_THAT_STATE: 'COUNTY_NAME_ALREADY_EXISTS_IN_THAT_STATE',
  COUNTY_NOT_FOUND: 'COUNTY_NOT_FOUND',
  COUNTY_NOT_FOUND_IN_THE_PLATFORM_CATALOG: 'COUNTY_NOT_FOUND_IN_THE_PLATFORM_CATALOG',
  CREDIT_REPORT_EXTRACT_FAILED: 'CREDIT_REPORT_EXTRACT_FAILED',
  CREDIT_REPORT_EXTRACT_REQUIRES_A_PDF_XML_ATTACH_REMAINS_ON_THE_MANUAL_FORM: 'CREDIT_REPORT_EXTRACT_REQUIRES_A_PDF_XML_ATTACH_REMAINS_ON_THE_MANUAL_FORM',
  CREDIT_REPORT_EXTRACT_VIA_TRIGGER_FAILED_AUTH: 'CREDIT_REPORT_EXTRACT_VIA_TRIGGER_FAILED_AUTH',
  CREDIT_REPORT_NOT_FOUND: 'CREDIT_REPORT_NOT_FOUND',
  CREDIT_REPORT_PDF_PARSE_IS_UNAVAILABLE: 'CREDIT_REPORT_PDF_PARSE_IS_UNAVAILABLE',
  CREDIT_REPORT_SUBJECT_NOT_FOUND: 'CREDIT_REPORT_SUBJECT_NOT_FOUND',
  DEFAULT_FEE_NOT_FOUND: 'DEFAULT_FEE_NOT_FOUND',
  DOCUMENTID_MUST_BE_A_PDF: 'DOCUMENTID_MUST_BE_A_PDF',
  DOCUMENTID_MUST_BE_A_PDF_OR_IMAGE_PAYSTUB: 'DOCUMENTID_MUST_BE_A_PDF_OR_IMAGE_PAYSTUB',
  DOCUMENTID_MUST_REFERENCE_A_DOCUMENT_ON_THIS_LOAN: 'DOCUMENTID_MUST_REFERENCE_A_DOCUMENT_ON_THIS_LOAN',
  DOCUMENTID_NOT_FOUND_ON_THIS_LOAN: 'DOCUMENTID_NOT_FOUND_ON_THIS_LOAN',
  DOCUMENT_ALREADY_ATTACHED_TO_THIS_REPORT: 'DOCUMENT_ALREADY_ATTACHED_TO_THIS_REPORT',
  DOCUMENT_NOT_FOUND: 'DOCUMENT_NOT_FOUND',
  EACH_EMPLOYMENT_ID_CAN_ONLY_BE_SENT_ONCE: 'EACH_EMPLOYMENT_ID_CAN_ONLY_BE_SENT_ONCE',
  EMAIL_NOT_FOUND: 'EMAIL_NOT_FOUND',
  EMPLOYER_MATCHES_MULTIPLE_EMPLOYMENTS_PASS_EMPLOYMENTID_TO_DISAMBIGUATE: 'EMPLOYER_MATCHES_MULTIPLE_EMPLOYMENTS_PASS_EMPLOYMENTID_TO_DISAMBIGUATE',
  EMPLOYMENTID_IS_NOT_AN_EMPLOYMENT_ON_THIS_BORROWER: 'EMPLOYMENTID_IS_NOT_AN_EMPLOYMENT_ON_THIS_BORROWER',
  EMPLOYMENT_ALREADY_LISTED: 'EMPLOYMENT_ALREADY_LISTED',
  EMPLOYMENT_NOT_FOUND: 'EMPLOYMENT_NOT_FOUND',
  EMPLOYMENT_NOT_FOUND_ON_THIS_BORROWER: 'EMPLOYMENT_NOT_FOUND_ON_THIS_BORROWER',
  ENTER_THE_CHANGED_CIRCUMSTANCE_THAT_REQUIRES_THIS_REVISED_LOAN_ESTIMATE: 'ENTER_THE_CHANGED_CIRCUMSTANCE_THAT_REQUIRES_THIS_REVISED_LOAN_ESTIMATE',
  ERROR_INSTANCEOF_ERROR_ERROR_MESSAGE_UNKNOWN_PIXELSIGN_ENVELOPE_STATUS: 'ERROR_INSTANCEOF_ERROR_ERROR_MESSAGE_UNKNOWN_PIXELSIGN_ENVELOPE_STATUS',
  ERROR_INSTANCEOF_ERROR_ERROR_MESSAGE_UNKNOWN_PIXELSIGN_SIGNER_FIELD: 'ERROR_INSTANCEOF_ERROR_ERROR_MESSAGE_UNKNOWN_PIXELSIGN_SIGNER_FIELD',
  ESCROW_POLICY_CONFLICT: 'ESCROW_POLICY_CONFLICT',
  ESCROW_POLICY_NOT_FOUND: 'ESCROW_POLICY_NOT_FOUND',
  EXTRACTED_PERIODEND_IS_BEFORE_PERIODSTART: 'EXTRACTED_PERIODEND_IS_BEFORE_PERIODSTART',
  EXTRACT_JOB_MISSING_DOCUMENTID: 'EXTRACT_JOB_MISSING_DOCUMENTID',
  EXTRACT_MISSING_VALID: 'EXTRACT_MISSING_VALID',
  EXTRACT_MISSING_VALID_YYYY_MM_DD: 'EXTRACT_MISSING_VALID_YYYY_MM_DD',
  EXTRACT_PRODUCED_NO_ACCOUNTS: 'EXTRACT_PRODUCED_NO_ACCOUNTS',
  EXTRACT_VALIDATION_FAILED: 'EXTRACT_VALIDATION_FAILED',
  FILE_EXCEEDS_15_MB_LIMIT: 'FILE_EXCEEDS_15_MB_LIMIT',
  FILE_EXCEEDS_25_MB_LIMIT: 'FILE_EXCEEDS_25_MB_LIMIT',
  FILE_IS_REQUIRED: 'FILE_IS_REQUIRED',
  FILE_IS_REQUIRED_MULTIPART_FIELD_FILE: 'FILE_IS_REQUIRED_MULTIPART_FIELD_FILE',
  FILE_MUST_BE_A_FORM_1003_PDF_PDF: 'FILE_MUST_BE_A_FORM_1003_PDF_PDF',
  FILE_MUST_BE_A_MISMO_XML_DOCUMENT_XML: 'FILE_MUST_BE_A_MISMO_XML_DOCUMENT_XML',
  FILL_IN_BEFORE_GENERATING_LEGAL_DOCUMENTS: 'FILL_IN_BEFORE_GENERATING_LEGAL_DOCUMENTS',
  FLOOD_ZONE_CATEGORY_MUST_BE_EMPTY_WHEN_THE_PROPERTY_IS_NOT_IN_A_FLOOD_ZONE: 'FLOOD_ZONE_CATEGORY_MUST_BE_EMPTY_WHEN_THE_PROPERTY_IS_NOT_IN_A_FLOOD_ZONE',
  FORM_1099_NOT_FOUND: 'FORM_1099_NOT_FOUND',
  HOA_NOT_FOUND_ON_THIS_LOAN: 'HOA_NOT_FOUND_ON_THIS_LOAN',
  IMPORT_REQUIRES_AT_LEAST_ONE_BORROWER: 'IMPORT_REQUIRES_AT_LEAST_ONE_BORROWER',
  INCOME_METHOD_NOT_AVAILABLE: 'INCOME_METHOD_NOT_AVAILABLE',
  INSURANCE_DOCUMENT_MUST_BE_A_PDF: 'INSURANCE_DOCUMENT_MUST_BE_A_PDF',
  INSURANCE_NOT_FOUND: 'INSURANCE_NOT_FOUND',
  INTENT_TO_PROCEED_BEFORE_APPLICATION: 'INTENT_TO_PROCEED_BEFORE_APPLICATION',
  INVALID_DOCUMENT_KIND: 'INVALID_DOCUMENT_KIND',
  INVALID_EMAIL_OR_PASSWORD: 'INVALID_EMAIL_OR_PASSWORD',
  INVALID_EXTRACT_OPTIONS: 'INVALID_EXTRACT_OPTIONS',
  INVALID_FEE_AMOUNT: 'INVALID_FEE_AMOUNT',
  INVALID_LENDER_COMPANY: 'INVALID_LENDER_COMPANY',
  INVALID_ORIGINATOR_COMPANY: 'INVALID_ORIGINATOR_COMPANY',
  INVALID_TABLE_FUNDING_LENDER_COMPANY: 'INVALID_TABLE_FUNDING_LENDER_COMPANY',
  INVALID_XML: 'INVALID_XML',
  INVITATION_HAS_EXPIRED: 'INVITATION_HAS_EXPIRED',
  INVITATION_IS_MISSING_COMPANY_DETAILS: 'INVITATION_IS_MISSING_COMPANY_DETAILS',
  INVITATION_IS_MISSING_LOAN_DETAILS: 'INVITATION_IS_MISSING_LOAN_DETAILS',
  INVITATION_NOT_FOUND: 'INVITATION_NOT_FOUND',
  INVITATION_NOT_FOUND_OR_ALREADY_ACCEPTED: 'INVITATION_NOT_FOUND_OR_ALREADY_ACCEPTED',
  ISSUE_A_CLOSING_DISCLOSURE_FIRST: 'ISSUE_A_CLOSING_DISCLOSURE_FIRST',
  IS_NOT_CONFIGURED_ON_THE_API: 'IS_NOT_CONFIGURED_ON_THE_API',
  KEYWORD_NOT_FOUND: 'KEYWORD_NOT_FOUND',
  LENDERCOMPANYID_MUST_REFERENCE_A_LENDER_COMPANY: 'LENDERCOMPANYID_MUST_REFERENCE_A_LENDER_COMPANY',
  LENDER_COMPANY_NOT_FOUND: 'LENDER_COMPANY_NOT_FOUND',
  LINKEDLIABILITYID_MUST_REFERENCE_A_LIABILITY_ON_THIS_LOAN: 'LINKEDLIABILITYID_MUST_REFERENCE_A_LIABILITY_ON_THIS_LOAN',
  LINKEDREALESTATEID_MUST_REFERENCE_REAL_ESTATE_ON_THIS_LOAN: 'LINKEDREALESTATEID_MUST_REFERENCE_REAL_ESTATE_ON_THIS_LOAN',
  LOANID_IS_REQUIRED_FOR_BORROWER_INVITATIONS: 'LOANID_IS_REQUIRED_FOR_BORROWER_INVITATIONS',
  LOANPROGRAMID_MUST_BELONG_TO_THE_TABLE_FUNDING_LENDER_WHEN_SET_OTHERWISE_THE_LENDER: 'LOANPROGRAMID_MUST_BELONG_TO_THE_TABLE_FUNDING_LENDER_WHEN_SET_OTHERWISE_THE_LENDER',
  LOANPROGRAMID_REQUIRES_A_TABLE_FUNDING_LENDER_OR_LENDER_COMPANY: 'LOANPROGRAMID_REQUIRES_A_TABLE_FUNDING_LENDER_OR_LENDER_COMPANY',
  LOAN_ESTIMATE_CANNOT_BE_REVISED_AFTER_THE_CLOSING_DISCLOSURE: 'LOAN_ESTIMATE_CANNOT_BE_REVISED_AFTER_THE_CLOSING_DISCLOSURE',
  LOAN_ESTIMATE_FEE_NOT_FOUND: 'LOAN_ESTIMATE_FEE_NOT_FOUND',
  LOAN_ESTIMATE_MISSING_PROPERTY_COSTS: 'LOAN_ESTIMATE_MISSING_PROPERTY_COSTS',
  LOAN_ESTIMATE_NOT_FOUND: 'LOAN_ESTIMATE_NOT_FOUND',
  LOAN_ISSUE_BLOCKED: 'LOAN_ISSUE_BLOCKED',
  LOAN_IS_NOT_EMPTY_IMPORT_REQUIRES_NO_BORROWERS_ASSETS_GIFTS_LIABILITIES_OR_REO: 'LOAN_IS_NOT_EMPTY_IMPORT_REQUIRES_NO_BORROWERS_ASSETS_GIFTS_LIABILITIES_OR_REO',
  LOAN_NOT_FOUND: 'LOAN_NOT_FOUND',
  LOAN_NOT_READY: 'LOAN_NOT_READY',
  LOAN_PROGRAM_MUST_BELONG_TO_THE_TABLE_FUNDING_LENDER_WHEN_SET_OTHERWISE_THE_LENDER: 'LOAN_PROGRAM_MUST_BELONG_TO_THE_TABLE_FUNDING_LENDER_WHEN_SET_OTHERWISE_THE_LENDER',
  LOAN_PROGRAM_NOT_FOUND: 'LOAN_PROGRAM_NOT_FOUND',
  LOAN_REFERENCE_IS_ALREADY_USED_BY_ANOTHER_LOAN: 'LOAN_REFERENCE_IS_ALREADY_USED_BY_ANOTHER_LOAN',
  LOAN_STATUS_BLOCKED_BY_TRID: 'LOAN_STATUS_BLOCKED_BY_TRID',
  LOAN_STATUS_CHANGED_WHILE_THIS_UPDATE_WAS_IN_PROGRESS_RELOAD_THE_LOAN_AND_TRY_AGAIN: 'LOAN_STATUS_CHANGED_WHILE_THIS_UPDATE_WAS_IN_PROGRESS_RELOAD_THE_LOAN_AND_TRY_AGAIN',
  LOAN_STATUS_REJECTED: 'LOAN_STATUS_REJECTED',
  LOGO_FILE_IS_EMPTY: 'LOGO_FILE_IS_EMPTY',
  LOGO_MUST_BE_2_MB_OR_SMALLER: 'LOGO_MUST_BE_2_MB_OR_SMALLER',
  LOGO_MUST_BE_PNG_JPEG_WEBP_GIF_OR_SVG: 'LOGO_MUST_BE_PNG_JPEG_WEBP_GIF_OR_SVG',
  MISMO_IMPORT_OPTIONS_INVALID: 'MISMO_IMPORT_OPTIONS_INVALID',
  MISMO_VALIDATION_FAILED: 'MISMO_VALIDATION_FAILED',
  MISMO_XML_MUST_CONTAIN_A_DEAL_DEAL_SETS_DEAL_SET_DEALS_DEAL: 'MISMO_XML_MUST_CONTAIN_A_DEAL_DEAL_SETS_DEAL_SET_DEALS_DEAL',
  MISSING_PERMISSION: 'MISSING_PERMISSION',
  MISSING_PERMISSION_INVITATION_CREATE: 'MISSING_PERMISSION_INVITATION_CREATE',
  MISSING_PERMISSION_INVITATION_READ: 'MISSING_PERMISSION_INVITATION_READ',
  MISSING_PERMISSION_LOAN_CREATE: 'MISSING_PERMISSION_LOAN_CREATE',
  MISSING_PERMISSION_LOAN_DOCUMENT_READ: 'MISSING_PERMISSION_LOAN_DOCUMENT_READ',
  MISSING_PERMISSION_LOAN_DOCUMENT_UPLOAD: 'MISSING_PERMISSION_LOAN_DOCUMENT_UPLOAD',
  MISSING_PERMISSION_LOAN_UPDATE: 'MISSING_PERMISSION_LOAN_UPDATE',
  MISSING_PERMISSION_LOAN_UPDATE_REQUIRED_TO_IMPORT_BORROWERS: 'MISSING_PERMISSION_LOAN_UPDATE_REQUIRED_TO_IMPORT_BORROWERS',
  MISSING_PERMISSION_TO_CHANGE_LOAN_STATUS_ON_THE_LENDER_COMPANY: 'MISSING_PERMISSION_TO_CHANGE_LOAN_STATUS_ON_THE_LENDER_COMPANY',
  NOTICE_DATE_BEFORE_DECISION: 'NOTICE_DATE_BEFORE_DECISION',
  NOT_A_MEMBER_OF_THIS_COMPANY: 'NOT_A_MEMBER_OF_THIS_COMPANY',
  NOT_FOUND: 'NOT_FOUND',
  NO_BORROWER_PARTIES_FOUND_IN_MISMO_DEAL: 'NO_BORROWER_PARTIES_FOUND_IN_MISMO_DEAL',
  NO_PDF_ON_THIS_TITLE_COMMITMENT: 'NO_PDF_ON_THIS_TITLE_COMMITMENT',
  NO_SIGNATURE_ENVELOPE_FOR_THIS_LOAN_ESTIMATE: 'NO_SIGNATURE_ENVELOPE_FOR_THIS_LOAN_ESTIMATE',
  NO_VESTING_DEED_ON_THIS_TITLE_FILE: 'NO_VESTING_DEED_ON_THIS_TITLE_FILE',
  ONE_OR_MORE_ARE_NOT_ON_THIS_LENDER_COMPANY: 'ONE_OR_MORE_ARE_NOT_ON_THIS_LENDER_COMPANY',
  ONLY_AN_IN_PROGRESS_SIGNATURE_CAN_BE_VOIDED: 'ONLY_AN_IN_PROGRESS_SIGNATURE_CAN_BE_VOIDED',
  ONLY_A_DRAFT_CLOSING_DISCLOSURE_CAN_BE_CHANGED: 'ONLY_A_DRAFT_CLOSING_DISCLOSURE_CAN_BE_CHANGED',
  ONLY_A_DRAFT_LOAN_ESTIMATE_CAN_BE_EDITED_PUBLISHED_OR_DELETED: 'ONLY_A_DRAFT_LOAN_ESTIMATE_CAN_BE_EDITED_PUBLISHED_OR_DELETED',
  ONLY_LENDER_COMPANIES_CAN_MANAGE_LINKED_ATTORNEYS: 'ONLY_LENDER_COMPANIES_CAN_MANAGE_LINKED_ATTORNEYS',
  ONLY_LENDER_COMPANIES_CAN_SET_A_PREFERRED_SERVICER: 'ONLY_LENDER_COMPANIES_CAN_SET_A_PREFERRED_SERVICER',
  ONLY_LENDER_STAFF_CAN_MAKE_THIS_DECISION: 'ONLY_LENDER_STAFF_CAN_MAKE_THIS_DECISION',
  ONLY_LENDER_STAFF_CAN_OVERRIDE_THIS_BLOCK: 'ONLY_LENDER_STAFF_CAN_OVERRIDE_THIS_BLOCK',
  ONLY_LENDER_USERS_OF_THE_LENDER_OR_TABLE_FUNDING_LENDER_OR_PLATFORM_ADMINS_CAN_OVERRIDE_GUIDELIN: 'ONLY_LENDER_USERS_OF_THE_LENDER_OR_TABLE_FUNDING_LENDER_OR_PLATFORM_ADMINS_CAN_OVERRIDE_GUIDELIN',
  ONLY_MORTGAGE_TRADELINES_CAN_BE_LINKED_TO_REAL_ESTATE: 'ONLY_MORTGAGE_TRADELINES_CAN_BE_LINKED_TO_REAL_ESTATE',
  ONLY_PLATFORM_ADMINS_CAN_CREATE_COMPANIES: 'ONLY_PLATFORM_ADMINS_CAN_CREATE_COMPANIES',
  ONLY_PLATFORM_ADMINS_CAN_DO_THIS: 'ONLY_PLATFORM_ADMINS_CAN_DO_THIS',
  ONLY_PLATFORM_ADMINS_CAN_INVITE_USERS: 'ONLY_PLATFORM_ADMINS_CAN_INVITE_USERS',
  ONLY_PLATFORM_ADMINS_CAN_LIST_USER_INVITATIONS: 'ONLY_PLATFORM_ADMINS_CAN_LIST_USER_INVITATIONS',
  ONLY_PLATFORM_ADMINS_CAN_MANAGE_COUNTIES: 'ONLY_PLATFORM_ADMINS_CAN_MANAGE_COUNTIES',
  ONLY_PLATFORM_ADMINS_CAN_MANAGE_PLATFORM_SETTINGS: 'ONLY_PLATFORM_ADMINS_CAN_MANAGE_PLATFORM_SETTINGS',
  ONLY_PLATFORM_ADMINS_CAN_MANAGE_SERVICERS: 'ONLY_PLATFORM_ADMINS_CAN_MANAGE_SERVICERS',
  ONLY_PLATFORM_ADMINS_CAN_MANAGE_TITLE_COMPANIES: 'ONLY_PLATFORM_ADMINS_CAN_MANAGE_TITLE_COMPANIES',
  ONLY_PLATFORM_ADMINS_CAN_MANAGE_USERS: 'ONLY_PLATFORM_ADMINS_CAN_MANAGE_USERS',
  ONLY_PLATFORM_ADMINS_CAN_RESEND_USER_INVITATIONS: 'ONLY_PLATFORM_ADMINS_CAN_RESEND_USER_INVITATIONS',
  ONLY_PLATFORM_ADMINS_CAN_UPDATE_COMPANIES: 'ONLY_PLATFORM_ADMINS_CAN_UPDATE_COMPANIES',
  ONLY_PLATFORM_ADMINS_MAY_UPDATE: 'ONLY_PLATFORM_ADMINS_MAY_UPDATE',
  ONLY_STAFF_ON_THIS_LOAN_CAN_SEE_THIS: 'ONLY_STAFF_ON_THIS_LOAN_CAN_SEE_THIS',
  ORIGINATORCOMPANYID_MUST_REFERENCE_AN_ORIGINATOR_COMPANY: 'ORIGINATORCOMPANYID_MUST_REFERENCE_AN_ORIGINATOR_COMPANY',
  ORIGINATORCOMPANYID_OR_LENDERCOMPANYID_IS_REQUIRED_WHEN_CREATING_A_LOAN_FROM_MISMO: 'ORIGINATORCOMPANYID_OR_LENDERCOMPANYID_IS_REQUIRED_WHEN_CREATING_A_LOAN_FROM_MISMO',
  ORIGINATOR_COMPANIES_REQUIRE_A_COMPANY_NMLS_NUMBER: 'ORIGINATOR_COMPANIES_REQUIRE_A_COMPANY_NMLS_NUMBER',
  ORIGINATOR_COMPANY_NOT_FOUND: 'ORIGINATOR_COMPANY_NOT_FOUND',
  ORIGINATOR_SIGNER_IS_REQUIRED: 'ORIGINATOR_SIGNER_IS_REQUIRED',
  PAYSTUB_EXTRACT_FAILED: 'PAYSTUB_EXTRACT_FAILED',
  PAYSTUB_EXTRACT_REQUIRES_A_PDF_OR_IMAGE_JPG_PNG_WEBP_GIF_HEIC: 'PAYSTUB_EXTRACT_REQUIRES_A_PDF_OR_IMAGE_JPG_PNG_WEBP_GIF_HEIC',
  PAYSTUB_EXTRACT_VIA_TRIGGER_FAILED_AUTH_SET_TRIGGER_SECRET_KEY_FROM_THE_TRIGGER_DEV_DASHBOARD: 'PAYSTUB_EXTRACT_VIA_TRIGGER_FAILED_AUTH_SET_TRIGGER_SECRET_KEY_FROM_THE_TRIGGER_DEV_DASHBOARD',
  PAYSTUB_NOT_FOUND: 'PAYSTUB_NOT_FOUND',
  PAYSTUB_PDF_PARSE_IS_UNAVAILABLE: 'PAYSTUB_PDF_PARSE_IS_UNAVAILABLE',
  PDF_1003_IMPORT_NEEDS_ON_THE_API: 'PDF_1003_IMPORT_NEEDS_ON_THE_API',
  PDF_EXTRACT_FAILED: 'PDF_EXTRACT_FAILED',
  PDF_GENERATION_FAILED: 'PDF_GENERATION_FAILED',
  PDF_PARSE_FAILED: 'PDF_PARSE_FAILED',
  PDF_SERVICE_IS_NOT_CONFIGURED_SET_PDF_SERVICE_URL: 'PDF_SERVICE_IS_NOT_CONFIGURED_SET_PDF_SERVICE_URL',
  PDF_SERVICE_REDIRECTED_CHECK_PDF_SERVICE_URL_SCHEME_HOST: 'PDF_SERVICE_REDIRECTED_CHECK_PDF_SERVICE_URL_SCHEME_HOST',
  PDF_SERVICE_UNREACHABLE: 'PDF_SERVICE_UNREACHABLE',
  PERIODEND_MUST_BE_ON_OR_AFTER_PERIODSTART: 'PERIODEND_MUST_BE_ON_OR_AFTER_PERIODSTART',
  PERSONAL_NMLS_NUMBER_IS_REQUIRED_FOR_RMLO_USERS: 'PERSONAL_NMLS_NUMBER_IS_REQUIRED_FOR_RMLO_USERS',
  PIXELSIGN_IS_UNREACHABLE: 'PIXELSIGN_IS_UNREACHABLE',
  PIXELSIGN_RETURNED_AN_UNEXPECTED_ENVELOPE_SHAPE: 'PIXELSIGN_RETURNED_AN_UNEXPECTED_ENVELOPE_SHAPE',
  PIXELSIGN_WEBHOOKS_ARE_NOT_CONFIGURED_SET_PIXELSIGN_WEBHOOK_SECRET: 'PIXELSIGN_WEBHOOKS_ARE_NOT_CONFIGURED_SET_PIXELSIGN_WEBHOOK_SECRET',
  PIXELSIGN_WEBHOOK_PAYLOAD_IS_INVALID: 'PIXELSIGN_WEBHOOK_PAYLOAD_IS_INVALID',
  PIXELSIGN_WEBHOOK_REJECTED: 'PIXELSIGN_WEBHOOK_REJECTED',
  PLATFORM_ADMIN_ONLY: 'PLATFORM_ADMIN_ONLY',
  PLATFORM_ADMIN_REQUIRED: 'PLATFORM_ADMIN_REQUIRED',
  PRE_APPROVAL_LETTER_IS_ONLY_AVAILABLE_WHEN_THE_LOAN_IS_PRE_APPROVED_OR_FURTHER_ALONG: 'PRE_APPROVAL_LETTER_IS_ONLY_AVAILABLE_WHEN_THE_LOAN_IS_PRE_APPROVED_OR_FURTHER_ALONG',
  PRE_APPROVAL_LETTER_REQUIRES_PROGRAM_PURCHASE_PRICE_MAX_CLTV_AND_RATE: 'PRE_APPROVAL_LETTER_REQUIRES_PROGRAM_PURCHASE_PRICE_MAX_CLTV_AND_RATE',
  PRE_APPROVAL_NOT_FOUND: 'PRE_APPROVAL_NOT_FOUND',
  PRE_APPROVAL_NOT_FOUND_ON_THIS_LOAN: 'PRE_APPROVAL_NOT_FOUND_ON_THIS_LOAN',
  PRIORINSURANCEID_MUST_BE_A_POLICY_ON_THIS_LOAN: 'PRIORINSURANCEID_MUST_BE_A_POLICY_ON_THIS_LOAN',
  PROGRAM_FEE_NOT_FOUND: 'PROGRAM_FEE_NOT_FOUND',
  PROGRAM_TERMS_INVALID: 'PROGRAM_TERMS_INVALID',
  PROVIDE_A_FILE_OR_DOCUMENTID: 'PROVIDE_A_FILE_OR_DOCUMENTID',
  PROVIDE_MULTIPART_FIELD_FILE_PDF_OR_BODY_DOCUMENTID: 'PROVIDE_MULTIPART_FIELD_FILE_PDF_OR_BODY_DOCUMENTID',
  PROVIDE_MULTIPART_FIELD_FILE_PDF_OR_IMAGE_OR_BODY_DOCUMENTID: 'PROVIDE_MULTIPART_FIELD_FILE_PDF_OR_IMAGE_OR_BODY_DOCUMENTID',
  PUBLISH_THE_LOAN_ESTIMATE_BEFORE_SENDING_IT_FOR_SIGNATURE: 'PUBLISH_THE_LOAN_ESTIMATE_BEFORE_SENDING_IT_FOR_SIGNATURE',
  RECEIPT_DATE_BEFORE_ISSUE_DATE: 'RECEIPT_DATE_BEFORE_ISSUE_DATE',
  RECEIPT_ONLY_ON_ISSUED_DISCLOSURE: 'RECEIPT_ONLY_ON_ISSUED_DISCLOSURE',
  REMINDERS_CAN_ONLY_BE_SENT_WHILE_THE_ENVELOPE_IS_AWAITING_SIGNATURES: 'REMINDERS_CAN_ONLY_BE_SENT_WHILE_THE_ENVELOPE_IS_AWAITING_SIGNATURES',
  REPORTDATE_IS_REQUIRED: 'REPORTDATE_IS_REQUIRED',
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  SELECTED_LOAN_PROGRAM_IS_INACTIVE: 'SELECTED_LOAN_PROGRAM_IS_INACTIVE',
  SERVICER_NOT_FOUND: 'SERVICER_NOT_FOUND',
  SETTLEMENT_AGENT_MUST_BELONG_TO_THE_SELECTED_TITLE_COMPANY: 'SETTLEMENT_AGENT_MUST_BELONG_TO_THE_SELECTED_TITLE_COMPANY',
  SIGNATURE_PARTY_INVALID: 'SIGNATURE_PARTY_INVALID',
  SIGNED_DOCUMENT_IS_MISSING: 'SIGNED_DOCUMENT_IS_MISSING',
  SIGNED_LOAN_ESTIMATE_IS_NOT_AVAILABLE_YET: 'SIGNED_LOAN_ESTIMATE_IS_NOT_AVAILABLE_YET',
  SPOUSE_CANNOT_BE_THE_SAME_BORROWER: 'SPOUSE_CANNOT_BE_THE_SAME_BORROWER',
  SPOUSE_COBORROWER_IS_NOT_ON_THIS_LOAN: 'SPOUSE_COBORROWER_IS_NOT_ON_THIS_LOAN',
  STAFF_MAY_NOT_UPDATE_FIELD: 'STAFF_MAY_NOT_UPDATE_FIELD',
  SUBJECT_PROPERTY_NOT_FOUND_ON_THIS_LOAN: 'SUBJECT_PROPERTY_NOT_FOUND_ON_THIS_LOAN',
  SURVEY_MUST_BE_A_PDF: 'SURVEY_MUST_BE_A_PDF',
  SWITCH_TO_THIS_COMPANY_BEFORE_INVITING_MEMBERS: 'SWITCH_TO_THIS_COMPANY_BEFORE_INVITING_MEMBERS',
  TABLEFUNDINGLENDERCOMPANYID_MUST_REFERENCE_A_LENDER_COMPANY: 'TABLEFUNDINGLENDERCOMPANYID_MUST_REFERENCE_A_LENDER_COMPANY',
  TABLE_FUNDING_LENDER_COMPANY_NOT_FOUND: 'TABLE_FUNDING_LENDER_COMPANY_NOT_FOUND',
  TAX_RETURN_NOT_FOUND: 'TAX_RETURN_NOT_FOUND',
  THAT_BORROWER_IS_ALREADY_LINKED_TO_ANOTHER_SUBJECT_ON_THIS_REPORT: 'THAT_BORROWER_IS_ALREADY_LINKED_TO_ANOTHER_SUBJECT_ON_THIS_REPORT',
  THE_HTML_EXCEEDS_PIXELSIGN_S_SIZE_LIMIT: 'THE_HTML_EXCEEDS_PIXELSIGN_S_SIZE_LIMIT',
  THE_HTML_IS_MISSING_SIGNATURE_FIELD_MARKERS: 'THE_HTML_IS_MISSING_SIGNATURE_FIELD_MARKERS',
  THE_ISSUE_DATE_CAN_T_BE_IN_THE_FUTURE: 'THE_ISSUE_DATE_CAN_T_BE_IN_THE_FUTURE',
  THE_LOAN_STATUS_CHANGED_RELOAD_AND_TRY_AGAIN: 'THE_LOAN_STATUS_CHANGED_RELOAD_AND_TRY_AGAIN',
  THE_SIGNED_LOAN_ESTIMATE_IS_AVAILABLE_AFTER_EVERY_SIGNER_COMPLETES: 'THE_SIGNED_LOAN_ESTIMATE_IS_AVAILABLE_AFTER_EVERY_SIGNER_COMPLETES',
  THIS_APPLICANT_ALREADY_HAS_PORTAL_ACCESS: 'THIS_APPLICANT_ALREADY_HAS_PORTAL_ACCESS',
  THIS_CLOSING_DISCLOSURE_IS_NO_LONGER_A_DRAFT_RELOAD_IT_TO_SEE_THE_LATEST_VERSION: 'THIS_CLOSING_DISCLOSURE_IS_NO_LONGER_A_DRAFT_RELOAD_IT_TO_SEE_THE_LATEST_VERSION',
  THIS_CONFIG_ERROR_PIXELSIGN_IS_NOT_CONFIGURED_PIXELSIGN_IS_NOT_CONFIGURED_SET_PIXELSIGN_API_KEY: 'THIS_CONFIG_ERROR_PIXELSIGN_IS_NOT_CONFIGURED_PIXELSIGN_IS_NOT_CONFIGURED_SET_PIXELSIGN_API_KEY',
  THIS_LOAN_ALREADY_HAS_A_DRAFT_CLOSING_DISCLOSURE: 'THIS_LOAN_ALREADY_HAS_A_DRAFT_CLOSING_DISCLOSURE',
  THIS_LOAN_ALREADY_HAS_A_DRAFT_LOAN_ESTIMATE: 'THIS_LOAN_ALREADY_HAS_A_DRAFT_LOAN_ESTIMATE',
  THIS_LOAN_DOES_NOT_INCLUDE_THAT_LEGAL_INSTRUMENT: 'THIS_LOAN_DOES_NOT_INCLUDE_THAT_LEGAL_INSTRUMENT',
  THIS_LOAN_ESTIMATE_ALREADY_HAS_A_SIGNATURE_IN_PROGRESS_VOID_IT_TO_SEND_AGAIN: 'THIS_LOAN_ESTIMATE_ALREADY_HAS_A_SIGNATURE_IN_PROGRESS_VOID_IT_TO_SEND_AGAIN',
  THIS_LOAN_ESTIMATE_IS_NO_LONGER_A_DRAFT_RELOAD_IT_TO_SEE_THE_LATEST_VERSION: 'THIS_LOAN_ESTIMATE_IS_NO_LONGER_A_DRAFT_RELOAD_IT_TO_SEE_THE_LATEST_VERSION',
  THIS_LOAN_ESTIMATE_VERSION_IS_ALREADY_SIGNED: 'THIS_LOAN_ESTIMATE_VERSION_IS_ALREADY_SIGNED',
  THIS_LOAN_IS_CLOSED_AND_CAN_NO_LONGER_BE_CHANGED: 'THIS_LOAN_IS_CLOSED_AND_CAN_NO_LONGER_BE_CHANGED',
  THIS_RESOURCE_CAN_ONLY_BE_MANAGED_FOR_LENDER_COMPANIES: 'THIS_RESOURCE_CAN_ONLY_BE_MANAGED_FOR_LENDER_COMPANIES',
  TITLE_COMMITMENT_MUST_BE_A_PDF: 'TITLE_COMMITMENT_MUST_BE_A_PDF',
  TITLE_COMMITMENT_NOT_FOUND: 'TITLE_COMMITMENT_NOT_FOUND',
  TITLE_COMPANY_NOT_FOUND: 'TITLE_COMPANY_NOT_FOUND',
  TITLE_FILE_NOT_FOUND_ON_THIS_LOAN: 'TITLE_FILE_NOT_FOUND_ON_THIS_LOAN',
  TITLE_REQUEST_BLOCKED: 'TITLE_REQUEST_BLOCKED',
  TOKEN_IS_REQUIRED: 'TOKEN_IS_REQUIRED',
  TRADELINE_NOT_FOUND: 'TRADELINE_NOT_FOUND',
  TRIGGER_DEV_UNREACHABLE_RUN_NPM_RUN_TRIGGER_DEV_IN_API: 'TRIGGER_DEV_UNREACHABLE_RUN_NPM_RUN_TRIGGER_DEV_IN_API',
  TRIGGER_DEV_UNREACHABLE_RUN_NPM_RUN_TRIGGER_DEV_IN_API_FOR_LOCAL_WORKERS: 'TRIGGER_DEV_UNREACHABLE_RUN_NPM_RUN_TRIGGER_DEV_IN_API_FOR_LOCAL_WORKERS',
  TRUSTEEID_MUST_BELONG_TO_THE_TABLE_FUNDING_LENDER_WHEN_SET_OTHERWISE_THE_LENDER: 'TRUSTEEID_MUST_BELONG_TO_THE_TABLE_FUNDING_LENDER_WHEN_SET_OTHERWISE_THE_LENDER',
  TRUSTEEID_REQUIRES_A_TABLE_FUNDING_LENDER_OR_LENDER_COMPANY: 'TRUSTEEID_REQUIRES_A_TABLE_FUNDING_LENDER_OR_LENDER_COMPANY',
  TRUSTEE_NOT_FOUND: 'TRUSTEE_NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  UNDERWRITING_BLOCKED: 'UNDERWRITING_BLOCKED',
  UNDERWRITING_GUIDELINE_NOT_FOUND: 'UNDERWRITING_GUIDELINE_NOT_FOUND',
  UNDERWRITING_RULE_INVALID: 'UNDERWRITING_RULE_INVALID',
  UNDERWRITING_RULE_NOT_FOUND: 'UNDERWRITING_RULE_NOT_FOUND',
  UNKNOWN_CURRENT_LOAN_STATUS: 'UNKNOWN_CURRENT_LOAN_STATUS',
  UNKNOWN_LEGAL_INSTRUMENT: 'UNKNOWN_LEGAL_INSTRUMENT',
  UNKNOWN_RULE_CODE_ON_EXISTING_ROW: 'UNKNOWN_RULE_CODE_ON_EXISTING_ROW',
  UNKNOWN_TARGET_STATUS: 'UNKNOWN_TARGET_STATUS',
  UNSUPPORTED_FILE_TYPE: 'UNSUPPORTED_FILE_TYPE',
  UNSUPPORTED_INVITATION_KIND: 'UNSUPPORTED_INVITATION_KIND',
  UPLOADED_FILE_IS_EMPTY: 'UPLOADED_FILE_IS_EMPTY',
  UPLOAD_A_TITLE_COMMITMENT_PDF: 'UPLOAD_A_TITLE_COMMITMENT_PDF',
  URLA_EXTRACT_FAILED: 'URLA_EXTRACT_FAILED',
  URLA_PARSE_FAILED: 'URLA_PARSE_FAILED',
  USER_IS_ALREADY_A_MEMBER_OF_THIS_COMPANY: 'USER_IS_ALREADY_A_MEMBER_OF_THIS_COMPANY',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  VERIFIEDBALANCEDOCUMENTID_MUST_BE_A_DOCUMENT_ON_THIS_LOAN: 'VERIFIEDBALANCEDOCUMENTID_MUST_BE_A_DOCUMENT_ON_THIS_LOAN',
  VESTING_DEED_MUST_BE_A_PDF: 'VESTING_DEED_MUST_BE_A_PDF',
  W_2_NOT_FOUND: 'W_2_NOT_FOUND',
  YOU_ARE_NOT_A_MEMBER_OF_THAT_COMPANY: 'YOU_ARE_NOT_A_MEMBER_OF_THAT_COMPANY',
  YOU_CANNOT_REMOVE_YOUR_OWN_ADMIN_ACCESS: 'YOU_CANNOT_REMOVE_YOUR_OWN_ADMIN_ACCESS',
  YOU_CAN_ONLY_ATTACH_COMPANIES_YOU_BELONG_TO: 'YOU_CAN_ONLY_ATTACH_COMPANIES_YOU_BELONG_TO',
  YOU_DO_NOT_HAVE_ACCESS_TO_THIS_LOAN: 'YOU_DO_NOT_HAVE_ACCESS_TO_THIS_LOAN',
  YOU_DO_NOT_HAVE_ACCESS_TO_UPDATE_THIS_LOAN: 'YOU_DO_NOT_HAVE_ACCESS_TO_UPDATE_THIS_LOAN',
} as const satisfies Record<
  (typeof API_ERROR_CODES)[number],
  (typeof API_ERROR_CODES)[number]
>

export type ApiErrorCode = (typeof API_ERROR_CODES)[number]
